import type { Moment } from '../types'
import { NumberUtils } from '../../../../utils'

type DwellTimelineInput = {
    [moment: Moment]: number
}

type DwellTimelineGroupedInput = {
    [type: string]: DwellTimelineInput
}

type DwellTimeLineGroupedData = {
    [fixture: string]: number[]
}

type DwellTimeLineGroupedLabels = Moment[]

export interface DwellTimelineGroupedOutput {
    values: DwellTimeLineGroupedData
    labels: DwellTimeLineGroupedLabels
    total: number
    perc: number | null
}

type DwellTimeLineGroupedReducer = [DwellTimeLineGroupedData, DwellTimeLineGroupedLabels?]

/**
 * Dwell timeline grouped by data type
 * @param {object} state
 */
function dwellTimelineGrouped<Group extends string = string>(payload = {}): DwellTimelineGroupedOutput {
    const data = payload as DwellTimelineGroupedInput
    const dataGroups = Object.keys(data) as Group[]

    // Iterate every type in the object
    const [values, momentLabels]: DwellTimeLineGroupedReducer = dataGroups.reduce(
        (carry: DwellTimeLineGroupedReducer, groupKey: Group): DwellTimeLineGroupedReducer => {
            const dataGroup: DwellTimelineInput = data[groupKey]

            // If the labels are not defined yet, take all moments from this type's data
            const labels: DwellTimeLineGroupedLabels = carry[1] || (Object.keys(dataGroup) as DwellTimeLineGroupedLabels)

            // Extract all values from this type's data
            return [
                {
                    ...carry[0],
                    [groupKey]: labels.map((label) => parseFloat(NumberUtils.withDecimalsIfNeeded(dataGroup[label]))),
                },
                labels,
            ]
        },
        [{}]
    )

    const labels = momentLabels as DwellTimeLineGroupedLabels

    return {
        values,
        labels,
        total: labels.length,
        perc: null,
    }
}

export default dwellTimelineGrouped
